const aqT = (k, d) => (window.aquainStrings && window.aquainStrings[k]) || d;
if (!customElements.get('aq-water-hardness')) {
  customElements.define('aq-water-hardness', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.$ = (s) => this.querySelector(s);
      this.models = JSON.parse(this.$('[data-models-json]').textContent);
      this.v1 = (Number(this.dataset.v1) || 12) * 1.78;
      this.v2 = (Number(this.dataset.v2) || 20) * 1.78;
      this.v1dh = Number(this.dataset.v1) || 12;
      this.$('[data-form]').addEventListener('submit', (e) => { e.preventDefault(); this.lookup(this.$('[data-plz]').value.trim(), true); });
      this.$('[data-plz]').addEventListener('focus', () => this.load(), { once: true });
      const add = this.$('[data-add]');
      if (add) add.addEventListener('click', () => this.addStrips(add));
      this.$('[data-apply]').addEventListener('click', () => this.apply());
      const io = 'IntersectionObserver' in window ? new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) { this.load(); io.disconnect(); } }, { rootMargin: '400px' }) : null;
      if (io) io.observe(this);
      const q = new URLSearchParams(location.search).get('plz');
      if (q) { this.$('[data-plz]').value = q; this.lookup(q); }
    }
    load() {
      if (!this.dataPromise) this.dataPromise = fetch(this.dataset.src).then((r) => r.json()).catch(() => null);
      return this.dataPromise;
    }
    error(msg) {
      const el = this.$('[data-error]');
      el.textContent = msg; el.hidden = !msg;
    }
    async lookup(plz, user) {
      if (!/^\d{4}$/.test(plz)) { this.error(aqT('plz_invalid', 'Bitte geben Sie eine vierstellige Schweizer Postleitzahl ein.')); return; }
      const d = await this.load();
      if (!d) { this.error(aqT('load_error', 'Die Daten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.')); return; }
      const list = d.plz[plz];
      if (!list) { this.error(aqT('plz_not_found', 'Diese Postleitzahl haben wir nicht gefunden. Postfach- und Firmen-Postleitzahlen sind nicht enthalten.')); return; }
      this.error('');
      this.data = d; this.plz = plz;
      this.list = list.filter((x, i) => i === 0 || x[2] >= 5);
      this.show(0);
      if (user && window.innerWidth < 750) this.$('[data-result]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    fmt(n) { return (Math.round(n * 10) / 10).toLocaleString('de-CH'); }
    level(v) {
      if (v < 7) return 'sehr weich';
      if (v < 15) return 'weich';
      if (v < 25) return 'mittelhart';
      if (v < 32) return 'ziemlich hart';
      if (v < 42) return 'hart';
      return 'sehr hart';
    }
    cls(v) { return v < 15 ? 'h1' : v < 25 ? 'h2' : v < 32 ? 'h3' : v < 42 ? 'h4' : 'h5'; }
    show(idx) {
      const d = this.data;
      const [bfs, ort, , x, y] = this.list[idx];
      const m = d.m[bfs] || ['', ''];
      const h = d.h[bfs];
      const res = this.$('[data-result]');
      res.hidden = false;
      const same = ort && m[0] && !m[0].startsWith(ort) && !ort.startsWith(m[0].replace(/ \(.*\)$/, ''));
      this.$('[data-place]').textContent = this.plz + ' ' + (same ? ort + ', Gemeinde ' + m[0] : m[0]) + ' (' + m[1] + ')';
      const others = this.$('[data-others]');
      others.innerHTML = '';
      if (this.list.length > 1) {
        others.hidden = false;
        others.insertAdjacentHTML('afterbegin', '<span>Diese PLZ betrifft mehrere Gemeinden:</span>');
        this.list.forEach((it, i) => {
          const b = document.createElement('button');
          b.type = 'button'; b.textContent = (d.m[it[0]] || [it[1]])[0];
          b.setAttribute('aria-pressed', String(i === idx));
          b.addEventListener('click', () => this.show(i));
          others.appendChild(b);
        });
      } else others.hidden = true;
      // marker + canton highlight
      const mk = this.querySelector('[data-marker]');
      mk.setAttribute('transform', 'translate(' + x + ' ' + y + ')'); mk.removeAttribute('hidden'); mk.parentNode.appendChild(mk);
      this.querySelectorAll('.aq-wh-k').forEach((p) => p.classList.toggle('is-active', p.dataset.k === m[1]));
      const tw = 'https://trinkwasser.ch/de/regionen?zip=' + this.plz;
      this.$('[data-tw]').href = tw;
      if (!h) {
        res.classList.add('is-nodata');
        this.$('[data-value-wrap]').hidden = true;
        this.$('[data-nodata]').hidden = false;
        this.$('[data-source]').innerHTML = '';
        this.reco(20, true);
        this.$('[data-calc-note]').textContent = aqT('ref_note', 'Ohne Ortswert rechnen wir mit dem Referenzwert 20 °fH. Bitte messen Sie nach.');
        return;
      }
      res.classList.remove('is-nodata');
      this.$('[data-value-wrap]').hidden = false;
      this.$('[data-nodata]').hidden = true;
      const [lo, hi, q, s, date] = h;
      let txt, calc;
      if (lo == null) { txt = aqT('below', 'unter ') + this.fmt(hi) + ' °fH'; calc = hi; }
      else if (hi == null) { txt = aqT('above', 'über ') + this.fmt(lo) + ' °fH'; calc = lo + 3; }
      else if (lo === hi) { txt = this.fmt(lo) + ' °fH'; calc = hi; }
      else { txt = this.fmt(lo) + '–' + this.fmt(hi) + ' °fH'; calc = hi; }
      const dh = (v) => this.fmt(v / 1.78);
      const dtxt = lo == null ? aqT('below', 'unter ') + dh(hi) : hi == null ? aqT('above', 'über ') + dh(lo) : lo === hi ? dh(lo) : dh(lo) + '–' + dh(hi);
      this.$('[data-fh]').textContent = txt;
      this.$('[data-dh]').textContent = '= ' + dtxt + ' °dH';
      const lv = lo == null ? this.level(hi - 0.1) : hi == null ? this.level(lo) : (this.level(lo) === this.level(hi - 0.01) ? this.level(lo) : this.level(lo) + ' bis ' + this.level(hi - 0.01));
      const badge = this.$('[data-level]');
      badge.textContent = lv.charAt(0).toUpperCase() + lv.slice(1);
      badge.className = 'aq-wh__badge aq-wh-' + this.cls(calc - 0.01);
      const src = d.src[s];
      const kind = q === 'c' ? aqT('kind_c', 'Härteklasse aus Netzproben') : q === 'z' ? aqT('kind_z', 'Versorgungszone') : q === 'l' ? aqT('kind_l', 'Kantonale bzw. regionale Liste nach Gemeinden') : aqT('kind_other', 'Angabe der Gemeinde / Wasserversorgung');
      const yr = /^\d{4}(-\d{2})?$/.test(date) ? +date.slice(0, 4) : 0;
      const old = yr && yr < 2020 ? aqT('old_value', ' · Ältere Angabe, bitte mit Teststreifen nachmessen.') : '';
      this.$('[data-source]').innerHTML = 'Quelle: <a href="' + src.url + '" target="_blank" rel="noopener">' + this.esc(src.name) + '</a> · ' + kind + (/^(abgerufen|Stand)/.test(date) ? ' · ' : ' · Stand ') + this.esc(yr && date.length === 7 ? date.slice(5) + '/' + date.slice(0, 4) : date) + this.esc(old);
      this.reco(calc, false);
      this.$('[data-calc-note]').textContent = (lo != null && hi != null && lo === hi ? aqT('calc_with', 'Berechnet mit ') : aqT('calc_upper', 'Zur Sicherheit berechnet mit dem oberen Wert ')) + this.fmt(calc) + aqT('calc_vary', ' °fH. Die Härte kann je nach Zone schwanken.');
    }
    esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }
    reco(fh, fallback) {
      this.calc = fh;
      const f = new Intl.NumberFormat('de-CH', { maximumFractionDigits: 0 });
      const litres = this.models.map((m) => Math.floor(m.cap * 20 / fh / 10) * 10);
      let main, alt;
      if (fh <= this.v1 + 0.001) { main = 0; alt = 1; }
      else if (fh <= this.v2 + 0.001) { main = 1; alt = 2; }
      else { main = 2; alt = 1; }
      const m = this.models[main];
      this.$('[data-model]').innerHTML = (m.img ? '<img src="' + m.img + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>') +
        '<div><a href="' + m.url + '">' + m.name + '</a><p>' + aqT('approx', 'ca. ') + f.format(litres[main]) + aqT('litres_per_regen', ' Liter pro Regeneration') + (m.price ? ' · ' + m.price : '') + '</p></div>';
      this.$('[data-models]').innerHTML = this.models.slice(0, 3).map((x, k) => {
        let cls = '', tag = '';
        if (k === main) { cls = 'is-reco'; tag = aqT('recommended_cap', 'Empfohlen'); }
        else if (k === alt) { cls = 'is-alt'; tag = alt > main ? aqT('alt_longer', 'Alternative: längere Intervalle') : aqT('alt_smaller', 'Alternative: kleiner und leichter'); }
        else if (k === 0 && fh > this.v1) { cls = 'is-off'; tag = aqT('only_up_to', 'nur bis ') + this.v1dh + aqT('dh_recommended', ' °dH empfohlen'); }
        return '<li class="' + cls + '"><span><a href="' + x.url + '">' + x.name + '</a>' + (tag ? '<small>' + tag + '</small>' : '') + '</span><span>' + f.format(litres[k]) + ' l</span></li>';
      }).join('');
      const wa = this.dataset.wa || 'https://wa.me/41792559392';
      const msg = aqT('v4_msg', 'Guten Tag, ich interessiere mich für Aquain V4 (hoher Verbrauch). PLZ: ') + (this.plz || '') + aqT('v4_hardness', ', Wasserhärte: ') + this.fmt(fh) + aqT('v4_use', ' °fH. Mein Einsatz: ');
      this.$('[data-wa-link]').href = wa.split('?')[0] + '?text=' + encodeURIComponent(msg);
      this.$('[data-reco] .aq-wh__reco-label').textContent = fallback ? aqT('reco_fallback', 'Empfehlung bei 20 °fH (Richtwert)') : aqT('reco_at', 'Unsere Empfehlung bei ') + this.fmt(fh) + ' °fH (' + this.fmt(fh / 1.78) + ' °dH)';
    }
    apply() {
      const calc = document.querySelector('aquain-capacity');
      if (!calc) { location.href = '/collections/aquain-systeme#modelle'; return; }
      const unit = calc.querySelector('[data-unit]');
      const hard = calc.querySelector('[data-hardness]');
      if (unit && unit.value !== '20') { unit.value = '20'; unit.dispatchEvent(new Event('input', { bubbles: true })); }
      hard.value = (Math.round(this.calc * 10) / 10).toString();
      hard.dispatchEvent(new Event('input', { bubbles: true }));
      calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    async addStrips(btn) {
      btn.disabled = true;
      try {
        const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.add), quantity: 1 }] }) });
        if (!r.ok) throw new Error();
        this.$('[data-added]').hidden = false;
        fetch('/cart.js').then((x) => x.json()).then((c) => document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => { el.textContent = c.item_count; })).catch(() => {});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) { this.$('[data-added]').hidden = false; this.$('[data-added]').textContent = aqT('add_failed', 'Das hat nicht geklappt. Bitte versuchen Sie es auf der Produktseite.'); }
      btn.disabled = false;
    }
  });
}
